export const styles = {
    divider: {
        width: '100%',
        margin: '0 0 1.5rem',
        borderColor: '#C0C9C1',
    },
};
